module.exports = __webpack_public_path__ + "img/access.87add1f5.svg";